import loadable from "@loadable/component";

export const RecommendationsPage = loadable(
  () => import("./RecommendationsPage"),
  {
    resolveComponent: mod => mod.RecommendationsPage,
  },
);

export * from "./types";
